// extracted by mini-css-extract-plugin
export var typingIndicator = "_jr-0";